export enum StatisticItemEnum {
  BUTTON_COUNT = 'BUTTON_COUNT',
  TAB_COUNT = 'TAB_COUNT',
  PAGE_COUNT = 'PAGE_COUNT',

  CHART_COUNT = 'CHART_COUNT',

  SERVICE_COUNT = 'SERVICE_COUNT'
}
